import React from 'react';
import {Paper} from 'material-ui';
import {withStyles} from 'material-ui/styles';
import {connect} from 'react-redux';
import classNames from 'classnames';
import {builderStyles} from '../../style/builder';
import {
    openEditTextSectionColumnsSingleMedia,
    changeSectionBgColor,
} from '../../actions';
import {pageSectionDropTarget} from '../../dsdt/section_drop_target';
import {pageSectionDragSource} from '../../dsdt/section_drag_source';
import SectionActions from './section_actions';
import ReactPlaceholder from 'react-placeholder';
import {sectionPlaceholder} from './section_placeholder';
import SectionTitle from './section_title';

class PageSection extends React.Component {
    editSection() {
        this.props.openEditTextSectionColumnsSingleMedia(
            this.props.pageId,
            this.props.id
        );
    }

    render() {
        const {
            isDragging,
            connectDragSource,
            connectDragPreview,
            connectDropTarget,
            classes,
            deleteSection,
            deletable,
            changeSectionBgColor,
            sectionBgColorId,
        } = this.props;

        const opacity = isDragging ? 0 : 1;

        let sectionPaperClassNames = classNames(
            classes.pbSection,
            classes.root,
            this.props.new && this.props.touched && classes.new,
            this.props.touched && !this.props.new && classes.touched
        );

        return connectDragPreview(
            connectDropTarget(
                <div>
                    <Paper
                        style={{opacity}}
                        className={sectionPaperClassNames}
                        elevation={2}
                    >
                        <SectionTitle
                            classes={classes}
                            sectionType={this.props.sectionType}
                            title={this.props.title}
                            connectDragSource={connectDragSource}
                            hideDragIcon={this.props.hideDragIcon}
                            changeSectionBgColor={(sectionBgColorId) =>
                                changeSectionBgColor(
                                    sectionBgColorId,
                                    this.props.id,
                                    this.props.pageId
                                )
                            }
                            sectionBgColorId={sectionBgColorId}
                        />

                        <ReactPlaceholder
                            rows={5}
                            ready={false}
                            customPlaceholder={sectionPlaceholder}
                        >
                            {''}
                        </ReactPlaceholder>

                        <SectionActions
                            classes={this.props.classes}
                            editSection={this.editSection.bind(this)}
                            deletable={deletable}
                            deleteSection={(ev) =>
                                deleteSection(ev, this.props.id)
                            }
                        />
                    </Paper>
                </div>
            )
        );
    }
}

const card = withStyles(builderStyles)(PageSection);

const pageSection = pageSectionDropTarget(pageSectionDragSource(card));

export default connect(
    () => {
        return {};
    },
    {
        openEditTextSectionColumnsSingleMedia,
        changeSectionBgColor,
    }
)(pageSection);



// WEBPACK FOOTER //
// ./src/containers/builder/sections/tab_dnd/section_text_columns_single_media.js